export default __webpack_public_path__ + "static/media/section-heading-voting.fb56a865.svg";